<template>
  <div class="hello">

    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="Name" prop="name">
        <el-input v-model="form.name" maxlength="10" show-word-limit :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="Medicine" prop="medicine">
        <el-input v-model="form.medicine" maxlength="10" show-word-limit :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="Doctor Signature">
        <el-input v-model="form.signature" maxlength="10" show-word-limit :disabled="true"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')">确认</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
export default {
  name: 'PrescriptionPage',
  data() {
      return {
        contirmApi: 'http://www,google.com',
        form: {
          name: '',
          medicine: '',
          signature: '',
        }, 
        rules: {
          name: [
            { required: true, message: '请输入患者姓名', trigger: 'blur' },
            { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
          ],
          medicine: [
            { required: true, message: '请选择药品名字', trigger: 'change' }
          ],
        }
      }
    },
  props: {
    msg: String,
  },
  methods: {
    onSubmit(formName) {
      alert('back page', formName)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted () {
    
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>
